import { useState, SyntheticEvent } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import LinkComponent from "@Components/Link";
import AccordionButton from "@Components/header/zipCodeBar/accordionButton/AccordionButton";
import Icon from "@wff/components/ui/icon";
import footerClasses from "@wff/styles/snippets/_footer.module.scss";
import { menuItem } from "./Footer";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "./accordion/accordionItems";
import footerMenuStyles from "./Footer.module.scss";

type FooterLinksProps = {
  menus: menuItem[];
};

export const FooterLinks = ({ menus }: FooterLinksProps) => {
  const [expanded, setExpanded] = useState(false);
  const [itemExpanded, setItemExpanded] = useState();
  const isMobile = useMediaQuery("(max-width:48em)");

  const toggleDrawer = (event: SyntheticEvent, item: any) => {
    event.preventDefault();
    setExpanded(!expanded);
    setItemExpanded(item);
  };

  return (
    <>
      {!isMobile ? (
        <section className={footerClasses["site-footer__menu"]}>
          <nav
            className={footerMenuStyles["linklist--footer-menu"]}
            aria-label="Footer Site Navigation"
            role="navigation"
          >
            <ul className={footerMenuStyles["linklist__links--level1"]}>
              {menus?.map((item) => {
                return (
                  <li
                    className={footerMenuStyles["link--level1"]}
                    key={item.title}
                  >
                    {item.title && (
                      <p className={footerMenuStyles["link__title"]}>
                        {item.title}
                      </p>
                    )}
                    <ul className={footerMenuStyles["link--level2"]}>
                      {item?.subMenus?.items?.map(({ title, link, icon }) => {
                        return (
                          <li
                            className={footerMenuStyles["link--level2"]}
                            key={title}
                          >
                            <LinkComponent href={link}>
                              <a
                                target={
                                  title === "Our People" ? "_blank" : "_self"
                                }
                                className={footerMenuStyles["link__anchor"]}
                                rel="noreferrer"
                              >
                                {/**TODO:- load icons from contentful */}
                                {icon && (
                                  <span
                                    className={footerMenuStyles["link__icon"]}
                                  >
                                    <Icon iconName="question" />
                                  </span>
                                )}
                                {title}
                              </a>
                            </LinkComponent>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                );
              })}
            </ul>
          </nav>
        </section>
      ) : (
        <div className={footerMenuStyles["container-mobile"]}>
          {menus?.map((item, index) => {
            return (
              <div key={index}>
                <Accordion
                  expanded={expanded && itemExpanded === item}
                  onChange={(e) => toggleDrawer(e, item)}
                >
                  <AccordionSummary>
                    {item.title && (
                      <h3 className={footerMenuStyles["link__title"]}>
                        {item.title}
                      </h3>
                    )}
                    <AccordionButton
                      onClick={(e: any) => toggleDrawer(e, item)}
                      active={expanded && itemExpanded === item}
                      iconName="bold-DownwardChevron"
                    />
                  </AccordionSummary>
                  <AccordionDetails>
                    {item?.subMenus?.items?.map(({ title, link, icon }) => {
                      return (
                        <li
                          className={footerMenuStyles["link--level2"]}
                          key={title}
                        >
                          <LinkComponent href={link}>
                            <a className={footerMenuStyles["link__anchor"]}>
                              {/**TODO:- load icons from contentful */}
                              {icon && (
                                <span
                                  className={footerMenuStyles["link__icon"]}
                                >
                                  <Icon iconName="question" />
                                </span>
                              )}
                              {title}
                            </a>
                          </LinkComponent>
                        </li>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
